module.exports = __webpack_public_path__ + "static/media/join-barn-family-two.10c69a4a.png";